import { put, takeEvery } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { UPDATE_APP, UpdateAppAction, updateAppEnd } from "../actions";

export function* updateApp(action: UpdateAppAction) {
    const { payload } = action;
    const { app } = payload;
    const { appId, ...theRest } = app;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore TemplateType vs string issue
        yield api.updateApp(appId, { set: theRest });
        yield put(updateAppEnd(undefined, app));
        yield put(addNotification(`${app.name} updated`));
    } catch (e) {
        yield put(updateAppEnd(e));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchUpdateApp() {
    yield takeEvery(UPDATE_APP, updateApp);
}
